// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__adWZh","placeholdersHeader":"styles_placeholdersHeader__2aAet","editorStyle":"styles_editorStyle__3S3g4","placeholdersBox":"styles_placeholdersBox__T3C3T"};